import PropTypes from 'prop-types';
import { colorLookup } from '@medifind/utils';
import { SVG } from './SVG';
const IconArrowForward = (props) => {
  const { color } = props;
  const colorCode = colorLookup(color) ?? colorLookup('blue');

  return (
    <SVG width="25" height="16" viewBox="0 0 33 21" fill={colorCode} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.5778 9.5117L22.3527 0.863042C21.7899 0.335366 20.877 0.335366 20.3142 0.863042C19.7512 1.39083 19.7512 2.2464 20.3142 2.77418L27.0786 9.11592L2.44142 9.11592C1.64541 9.11592 1 9.721 1 10.4673C1 11.2134 1.64541 11.8186 2.44142 11.8186L27.0786 11.8186L20.3144 18.1604C19.7515 18.6881 19.7515 19.5437 20.3144 20.0715C20.5958 20.3352 20.9648 20.4673 21.3337 20.4673C21.7026 20.4673 22.0715 20.3352 22.3529 20.0715L31.5778 11.4228C32.1407 10.8951 32.1407 10.0395 31.5778 9.5117Z"
        fill={colorCode}
        strokeWidth="0.5"
      />
    </SVG>
  );
};
IconArrowForward.propTypes = {
  color: PropTypes.string,
};
export { IconArrowForward as default, IconArrowForward };
